<template>
    <el-dialog class="peiso-modal kseries-container"
    :visible.sync="isOpen"
    :modal-append-to-body="false"
    :close-on-click-modal='false'
    :close-on-press-escape="false"
    width="550px"
    :before-close="handleClose"
    center>

        <div v-if="isUploadingData" class="loading-container d-flex align-items-center justify-content-center w-100">
            <div class="loading-label-wrapper">
                <div v-if="!isDoneUploading" class="loading m-bottom-1rem text-center">
                    <i class="el-icon-loading"></i>
                </div>
                <span v-if="!isDoneUploading" class="text-center message">
                    Setting up your account.
                    <span class="d-block">Please wait...</span>
                </span>
                <div v-if="isDoneUploading" class="text-center message">
                    <div>
                        <img src="@/assets/blue-success.png" alt="">
                    </div>
                    <span>
                    All done!
                    <span class="d-block">You've successfully set up your account.</span>

                </span>
                <el-button type="peiso-primary-pink m-top-1-5rem" class="w-100" @click="hideModal">Okay</el-button>
                </div>
            </div>
        </div>

        <div class="header-container">
            <span>Select business</span>
        </div>
        <div class="body-container">
            <div class="field-group">
                <div v-if="business">
                    <el-select v-model="businessValue" placeholder="Select a business" class="peiso-select-default w-100 m-bottom-1rem" @change="handleChange">
                        <el-option v-for="(item, i) in business" :key="`business-${i}`" :value="item.businessName">{{ item.businessName }}</el-option>
                    </el-select>
                </div>
            </div>

            <template>
                <template>
                    <div class="header-container m-top-1rem m-bottom-1rem">
                        <span>Select Business location</span>
                    </div>
                    <div class="list-field-group" :class="{'d-flex align-items-center justify-content-center' : !businessLocation.length}">
                        <div v-if="businessLocation.length" v-for="(item, i) in businessLocation" :key="`business-location-${i}`" class="list-grp-container d-flex align-items-center gap-16 cursor-pointer" @click="updateSelected(i)">

                            <img v-if="!item.isSelected" width="20px" src="@/assets/circle.svg" alt="">
                            <img v-else width="20px" src="@/assets/selected.png" alt="">

                            <div>
                                <span>{{ item.blName }}</span>
                            </div>

                        </div>

                        <div v-if="!businessLocation.length" class="text-center">
                            <span>No business location displayed</span>
                        </div>
                    </div>

                </template>

                <div class="d-flex gap-10 m-top-1rem">
                    <el-button type="peiso-default" class="w-100" @click="handleClose">Cancel</el-button>
                    <el-button v-if="!isLoading" type="peiso-primary-pink" class="w-100" @click="confirmBusiness">Confirm</el-button>
                    <el-button v-if="isLoading" type="peiso-primary-pink" class="w-100"><i class="el-icon-loading"></i> Loading...</el-button>
                </div>
            </template>
        </div>

    </el-dialog>
</template>

<style lang='scss'>
@import '../../../static/scss/colors.scss';
@import '../../../static/scss/fonts/fonts.scss';
    .kseries-container {
        .el-button--peiso-default {
            > span {
                width: 100%;
            }
        }

        .el-dialog__headerbtn {
            display: none;
        }

        .list-grp-container {
            padding: 1rem;
        }

        .field-group {
            span {
                @include montserrat-font(14px, normal, 500, $white) {
                    margin-bottom: 10px;
                }
            }
        }

        .list-field-group {
            min-height: 200px;
            max-height: 400px;
            overflow: hidden auto;
            @include montserrat-font(14px, normal, 500, $white) {
                background-color: $dark-blue;
                padding: 10px;
            }
            .list-grp-container {

            }
        }

        .loading-container {
            position: absolute;
            left: 0px;
            top: 0px;
            height: 100%;
            background: var(--background-color-4);
            z-index: 10;
            border-radius: 10px;

            .loading-label-wrapper {
                padding: 2rem 2rem;
                box-shadow: 0 1px 3px rgba(0,0,0,.3);
                background-color: $gray2;
                min-width: 500px;
                text-align: center;
                z-index: 1000;
                @include montserrat-font(14px, normal, 500, $white);

                .loading {
                    font-size: 50px;
                }

                .message {
                    line-height: 1.5;

                    img {
                        margin-bottom: 1rem;
                    }
                }

                .el-button--peiso-primary-pink {
                    max-width: 200px;
                    margin-left: auto;
                    margin-right: auto;
                    font-size: 15px;
                }
            }
        }
    }
</style>

<script>
    import utils from '../../utils/utils'
    import dashboard from '@/api/dashboard'
    import api from '../../api/api'
    export default {
        data() {
            return {
                isOpen: false,
                isLoading: false,
                businessValue: '',
                selectedBusiness: {},
                businessLocation: [],
                businessTest: [
                    {
                        businessName: 'Business Test 1'
                    },
                    {
                        businessName: 'Business Test 2'
                    },
                    {
                        businessName: 'Business Test 3'
                    }
                ],
                isUploadingData: false,
                isDoneUploading: false
            }
        },
        props: {
            open: {
                default: false
            },
            business: {
                default: null
            },
            isDashboardPage: {
                default: false
            },
            isPro: {
                default: false
            }
        },
        watch: {
            open(val) {
                this.isOpen = val

                console.log(val)
            },
            business(val) {
                console.log(val)
                this.businessLocation = []
            },
        },
        computed: {
            selectAlready() {
                const data = this.businessLocation.filter((n) => n.isSelected == true)

                return data.length ? true : false
            }
        },
        methods: {
            handleClose() {
                this.isOpen = false
                this.$emit('close-modal')
            },

            handleChange(e) {
                const data = this.business.find(n => n.businessName == e)
                var addObj = data.businessLocations.map((n) => {
                    n.isSelected = false

                    return n
                })
                this.businessLocation = addObj

            },
            updateSelected(idx) {
                this.businessLocation = this.businessLocation.map((n) => {
                    n.isSelected = false

                    return n
                })

                this.businessLocation[idx].isSelected = true
                this.selectedBusiness = this.businessLocation[idx]
            },

            async confirmBusiness() {
                if (this.selectAlready) {
                    this.isLoading = true
                    let selected = this.selectedBusiness
                    localStorage.setItem('blId', selected.blId)

                    try {
                        await  api.saveKseriesBusinessLocation({businessId: selected.business_id, businessLocationId: selected.blId});
                        
                        this.isUploadingData = true
                        
                        await api.kseriesLoadOrders({businessLocationId: selected.blId});
                       
                        this.isDoneUploading = true

                    } catch (error) {
                        this.isDoneUploading = true
                        this.isOpen = false
                        location.reload()
                        this.$emit('flagged')
                    }
                }
            },

            hideModal() {
                this.isOpen = false
                this.isUploadingData = false
                this.isLoading = false
                if (this.isDashboardPage) {
                    this.$emit('flagged')
                } else {
                    location.reload()
                }
            }
        },
        mounted() {

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/modal/businessLocation.vue